import { Navigate, Outlet, useLocation } from "react-router-dom";

import { refusalText } from "../api/errors";
import { Button } from "../ui/Button";
import { Card } from "../ui/Card";
import { Loading } from "../ui/EmptyState";
import { MeProvider, useSession } from "./auth";
import { PlainFrame } from "./PlainFrame";

/**
 * Everything but the sign-in screen sits behind this. A person who is not signed in goes to the
 * sign-in screen (and comes back to the address they asked for); a person who must change a first
 * password sees only the change-password screen.
 */
export function AuthGate() {
  const session = useSession();
  const location = useLocation();

  if (session.status === "loading") {
    return (
      <PlainFrame>
        <Loading>Checking that you are signed in</Loading>
      </PlainFrame>
    );
  }
  if (session.status === "signed_out") {
    return <Navigate to="/sign-in" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  if (session.status === "error") {
    return (
      <PlainFrame>
        <Card aria-labelledby="gate-error-title">
          <h1 id="gate-error-title">The app cannot reach the server</h1>
          <p role="alert">{refusalText(session.error)}</p>
          <Button variant="primary" onClick={session.retry}>
            Try again
          </Button>
        </Card>
      </PlainFrame>
    );
  }

  const { me } = session;
  if (me.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  return (
    <MeProvider me={me}>
      <Outlet />
    </MeProvider>
  );
}
